import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import {
  List,
  ListSubheader,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Button,
  Drawer,
  IconButton,
} from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import Collapse from "@mui/material/Collapse";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import AbcIcon from "@mui/icons-material/Abc";
import CodeIcon from "@mui/icons-material/Code";
import StorageIcon from "@mui/icons-material/Storage";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { Link as RouterLink } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";

export const BlockResponsePage = (props) => {
  const [open, setOpen] = useState(true);
  const [blocksOpen, setBlocksOpen] = useState(true);
  const [menu, setMenu] = useState(false);
  return (
    <div className="get-started-page">
      <header className="topbar">
        <IconButton
          className="menu-button"
          onClick={() => {
            setMenu(true);
          }}
        >
          <MenuIcon />
        </IconButton>
        <div className="topbar-logo">
          <a href="https://www.fabloq.com">
            <div class="surface">
              <p class="f-letter">F</p>
              <div class="block"></div>
            </div>
          </a>
        </div>
        <span className="topbar-docs">Docs</span>
      </header>

      <main className="content">
        <Drawer
          open={menu}
          onClose={() => {
            setMenu(false);
          }}
          className="drawer"
        >
          <List
            sx={{
              width: "100%",

              bgcolor: "background.paper",
            }}
            component="nav"
            aria-labelledby="nested-list-subheader"
            // subheader={
            //   <ListSubheader component="div" id="nested-list-subheader">
            //     Nested List Items
            //   </ListSubheader>
            // }
          >
            <ListItemButton component={RouterLink} to="/getstarted">
              <ListItemIcon>
                <AbcIcon color="#ff5757" />
              </ListItemIcon>
              <ListItemText primary="Get Started" />
            </ListItemButton>
            <ListItemButton
              onClick={() => {
                setBlocksOpen(!blocksOpen);
              }}
            >
              <ListItemIcon>
                <CodeIcon />
              </ListItemIcon>
              <ListItemText primary="Blocks" />
              {open ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={blocksOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/overview"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Overview" />
                </ListItemButton>
                <ListSubheader component="div" id="nested-list-subheader">
                  Control Blocks
                </ListSubheader>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/variables"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Variable" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/response"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Response" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/if"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="If" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/loop"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Loop" />
                </ListItemButton>
                <ListSubheader component="div" id="nested-list-subheader">
                  Database Blocks
                </ListSubheader>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/fetchone"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Fetch One" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/fetchmany"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Fetch Many" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/create"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Create" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/update"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Update" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/delete"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Delete" />
                </ListItemButton>
                <ListSubheader component="div" id="nested-list-subheader">
                  Authentication Blocks
                </ListSubheader>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/usersignup"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="User Signup" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/usersignin"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="User Sign In" />
                </ListItemButton>
              </List>
            </Collapse>
            {/* <ListItemButton>
              <ListItemIcon>
                <StorageIcon />
              </ListItemIcon>
              <ListItemText primary="Database" />
            </ListItemButton>
            <ListItemButton>
              <ListItemIcon>
                <DashboardIcon />
              </ListItemIcon>
              <ListItemText primary="Dashboard" />
            </ListItemButton> */}
          </List>
        </Drawer>
        <div className="sidebar" style={{ height: window.innerHeight - 55 }}>
          <List
            sx={{
              width: "100%",

              bgcolor: "background.paper",
            }}
            component="nav"
            aria-labelledby="nested-list-subheader"
            // subheader={
            //   <ListSubheader component="div" id="nested-list-subheader">
            //     Nested List Items
            //   </ListSubheader>
            // }
          >
            <ListItemButton component={RouterLink} to="/getstarted">
              <ListItemIcon>
                <AbcIcon color="#ff5757" />
              </ListItemIcon>
              <ListItemText primary="Get Started" />
            </ListItemButton>
            <ListItemButton
              onClick={() => {
                setBlocksOpen(!blocksOpen);
              }}
            >
              <ListItemIcon>
                <CodeIcon />
              </ListItemIcon>
              <ListItemText primary="Blocks" />
              {open ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={blocksOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/overview"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Overview" />
                </ListItemButton>
                <ListSubheader component="div" id="nested-list-subheader">
                  Control Blocks
                </ListSubheader>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/variables"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Variable" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/response"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Response" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/if"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="If" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/loop"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Loop" />
                </ListItemButton>
                <ListSubheader component="div" id="nested-list-subheader">
                  Database Blocks
                </ListSubheader>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/fetchone"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Fetch One" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/fetchmany"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Fetch Many" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/create"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Create" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/update"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Update" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/delete"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Delete" />
                </ListItemButton>
                <ListSubheader component="div" id="nested-list-subheader">
                  Authentication Blocks
                </ListSubheader>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/usersignup"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="User Signup" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/usersignin"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="User Sign In" />
                </ListItemButton>
              </List>
            </Collapse>
            {/* <ListItemButton>
              <ListItemIcon>
                <StorageIcon />
              </ListItemIcon>
              <ListItemText primary="Database" />
            </ListItemButton>
            <ListItemButton>
              <ListItemIcon>
                <DashboardIcon />
              </ListItemIcon>
              <ListItemText primary="Dashboard" />
            </ListItemButton> */}
          </List>
        </div>
        <div className="article">
          <div className="article-left" />
          <div className="article-content">
            <h2 className="topic-title" id="response-block">
              <span className="hashtag">#</span> Response Block
            </h2>
            <p className="topic-para">
              Response block sends response when request is sent to API
              endpoint. It consists of status code like 200, 404 etc and data if
              you want to send any data with the response. Data is sent in the
              form of JSON.
            </p>
            <div className="topic-para-note">
              <p className="topic-para">
                <span className="topic-para-bold">NOTE:</span> Every endpoint
                must end with a response block.
              </p>
            </div>
            <h2 className="topic-title" id="how-to-create-response-block">
              <span className="hashtag">#</span> How to create a response block
            </h2>
            <ol>
              <li className="topic-para">
                Select “Response” under “Control Blocks”.
              </li>
              <li className="topic-para">Select appropriate status code</li>
              <li className="topic-para">
                To add data press plus button and enter name of the key and
                value
              </li>
              <li className="topic-para">
                To use variable, put variable name in double curly braces. Eg:
              </li>
              <div className="topic-code">
                <p className="topic-para">{"{{variable_name}}"}</p>
              </div>
            </ol>
            <div className="topic-footline"></div>
            <div className="topic-buttons">
              <Button component={RouterLink} to="/blocks/variables">
                <ChevronLeftIcon /> Variables
              </Button>
              <Button component={RouterLink} to="/blocks/if">
                If <ChevronRightIcon />
              </Button>
            </div>
          </div>
          <div className="article-right" />
        </div>
        <div className="index">
          <a className="index-title">Contents</a>
          <a className="index-topic" href="#response-block">
            Response Block
          </a>
          <a className="index-topic" href="#how-to-create-response-block">
            How to create a response block
          </a>
          {/* <div className="index-sublist">
              <p className="index-subtopic">Sub Topic</p>
              <p className="index-subtopic">Sub Topic</p>
              <p className="index-subtopic">Sub Topic</p>
              <p className="index-subtopic">Sub Topic</p>
            </div> */}
        </div>
      </main>
    </div>
  );
};
